'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultProps = {
    id: '',
    expanded: false,
    className: 'accordion__body',
    hideBodyClassName: 'accordion__body--hidden',
    role: ''
};

var AccordionItemBody = function AccordionItemBody(props) {
    var id = props.id,
        expanded = props.expanded,
        children = props.children,
        className = props.className,
        hideBodyClassName = props.hideBodyClassName,
        role = props.role;

    var bodyClass = (0, _classnames2.default)(className, _defineProperty({}, hideBodyClassName, !expanded));
    var ariaHidden = !expanded;
    return _react2.default.createElement(
        'div',
        {
            id: id,
            className: bodyClass,
            'aria-hidden': ariaHidden,
            'aria-labelledby': id.replace('accordion__body-', 'accordion__title-'),
            role: role
        },
        children
    );
};

AccordionItemBody.defaultProps = defaultProps;
// We need this to be able to assign correct params to element.
// Minifiers modify component name
AccordionItemBody.accordionElementName = 'AccordionItemBody';

exports.default = AccordionItemBody;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-accessible-accordion/dist/AccordionItemBody/accordion-item-body.js
// module id = 1234
// module chunks = 2